// Page Title: Secure web3login into your WordPress website with crypto wallets.
// Subtitle: Unlock the Future of Digital Identity with Our Web3 Plugin!

import { AiOutlineUsergroupAdd, AiOutlineWallet } from "react-icons/ai";
import { MdOutlineCode, MdOutlineIntegrationInstructions, MdOutlineToken } from "react-icons/md";

//Main Video: https://youtu.be/7XZ501n-OBM
export const webData = [
    {
        title: "Crypto Wallet Login to WordPress",
        video: false,
        videoId: "",
        videoType: "",
        icon: <AiOutlineWallet className='text-white fs-5' />
    },
    {
        title: "NFT token gating (Access based on NFT owned)",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdOutlineToken className='text-white fs-5' />
    },
    {
        title: "NFT-based role mapping",
        video: false,
        videoId: "",
        videoType: "",
        icon: <AiOutlineUsergroupAdd className='text-white fs-5' />
    },
    {
        title: "Partial Token Gating",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdOutlineToken className='text-white fs-5' />
    },
    {
        title: "Web3 Login Shortcodes",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdOutlineCode className='text-white fs-5' />
    },
    {
        title: "Web3 integration with WooCommerce, BuddyPress, MemberPres, LearnDash, etc.",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdOutlineIntegrationInstructions className='text-white fs-5' />
    }
]